import { ERCButton } from 'components/button';
import { ERCText } from 'components/text';
import React, { useMemo, useState } from 'react';
import {useLocation, } from 'react-router-dom';
import { toast } from 'react-toastify';
import OTPInput from 'components/Input/OTPInput';
import ERCInput from 'components/Input';
import { ERCForm } from 'components/form';
import { useDispatch } from 'react-redux';
import { showModal } from 'store/reducers/modal';

const ForgotPasswordModal = () => {

    const dispatch = useDispatch();
    // const navigate = useNavigate()
    const [email, setEmail] = useState('')
    const [otp, setOtp] = useState()

    // const onSuccess = () => {
    //     toast.success('Code sent to your email. ')
    //     navigate(`/forgot-password?page=otp&email=${email}`)
    // }
    // const schema = Yup.object().shape({
    //     email: Yup.string().required(),
    // });
    const { search } = useLocation()

    const forms = useMemo(() => {
        return {
            "default": {
                header: 'Forgot Password?',
                btnText: 'Submit',
                // url: '/forgot-password',
                // method: 'post',
                onSuccess: () => {
                    // console.log({ res, req })
                    toast.success(`Code sent to your email `)
                    dispatch(showModal({ content: (<ForgotPasswordModal />) }))
                },
                // schema: Yup.object().shape({
                //     email: Yup.string().required(),
                // }),
                onClick: dispatch(showModal({ content: (<ForgotPasswordModal />) })),
                fields: [{ type: 'email', name: 'email', label: 'Email', onChange: (e) => setEmail(e.target.value) }]
            },
            "validate-otp": {
                header: 'OTP Verification',
                btnText: 'Continue',
                // url: '/validate-otp',
                // method: 'get',
                onSuccess: () => {
                    toast.success('OTP validated successfully.')
                    dispatch(showModal({ content: (<ForgotPasswordModal />) }))
                },
                // schema: Yup.object().shape({
                //     otp: Yup.string().required(),
                // }),
                // onClick: dispatch(showModal({ content: (<ForgotPasswordModal />) })),
                fields: [],
                Component: <div className='w-100 flex !justify-center'><OTPInput onChange={setOtp} name={'otp'} /></div>
            },
            "change-password": {
                header: 'Password Reset',
                btnText: 'Reset Password',
                // url: '/forgot-password/reset',
                // method: 'put',
                onSuccess: () => {
                    toast.success('Password reset successful.')
                    dispatch(showModal({ content: (<ForgotPasswordModal />) }))
                },
                // schema: Yup.object().shape({
                //     newPassword: Yup.string().required(),
                //     confirmPassword: Yup.string().required(),
                // }),
                // onClick: dispatch(showModal({ content: (<ForgotPasswordModal />) })),
                fields: [
                    { hidden: true, type: 'email', name: 'email', value: email },
                    { hidden: true, type: 'number', name: 'otp', value: otp },
                    { type: 'password', name: 'newPassword', label: 'New password' },
                    { type: 'password', name: 'confirmPassword', label: 'Confirm passwoord' },
                ]
            }
        }
    }, [email, otp, dispatch])

    const currentForm = useMemo(() => {
        // const searchParams = new URLSearchParams(search)
        // const page = Object.fromEntries(searchParams).page?.toLowerCase()
        // console.log(page)
        // if (page && forms[page]) return forms[page]
        return forms.default
        // eslint-disable-next-line
    }, [search])

    // const formClass = 'w-[500px] mx-auto flex flex-col items-center justify-center bg-[white] p-[50px] shadow-[_5px_5px_4px_rgba(0,0,0,0.25)] rounded-[5px] '
    const btnStyle = { width: '400px', weight: '700', color: '#00296B', bgcolor: '#FFD600', className: '!mt-[56px] mb-[16px]', width: '430px', size: '16px' }
    return (


        <div style={{ padding: '58px 220px', display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }} >

            <ERCForm
                btnText={currentForm.btnText}
                //  url={currentForm.url} 
                onSuccess={currentForm.onSuccess}
                // method={currentForm.method} 
                // validationSchema={currentForm.schema}
                btnClass={btnStyle}
            >
                <ERCText size='32px' weight='700' lHeight='40px' color='#050505' align='center' >
                    {currentForm.header}
                </ERCText>

                <div className='w-[400px] mt-[30px]'>
                    {
                        currentForm.fields.map(field => <ERCInput key={field.label} {...field} />)
                    }
                    {
                        currentForm.Component
                    }
                </div>
                {/* <ERCInput containerClass='!w-[430px] mt-[80px] ' label='Email Address/Phone Number' placeholder='Enter email address or phone number' />
                <ERCButton weight='700' color='#00296B' bgcolor='#FFD600' className='!mt-[56px] mb-[16px]' width='430px' size='16px' > Submit </ERCButton> */}

            </ERCForm>

            {/* <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }} >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
                    <g clip-path="url(#clip0_1058_2665)">
                        <path d="M7.375 4.375H8.625V5.625H7.375V4.375ZM7.375 6.875H8.625V10.625H7.375V6.875ZM8 1.25C4.55 1.25 1.75 4.05 1.75 7.5C1.75 10.95 4.55 13.75 8 13.75C11.45 13.75 14.25 10.95 14.25 7.5C14.25 4.05 11.45 1.25 8 1.25ZM8 12.5C5.24375 12.5 3 10.2563 3 7.5C3 4.74375 5.24375 2.5 8 2.5C10.7563 2.5 13 4.74375 13 7.5C13 10.2563 10.7563 12.5 8 12.5Z" fill="#FFD600" />
                    </g>
                    <defs>
                        <clipPath id="clip0_1058_2665">
                            <rect width="15" height="15" fill="white" transform="translate(0.5)" />
                        </clipPath>
                    </defs>
                </svg>
                <ERCText color='#9A9AAA' size='14px' weight='600' lHeight='20px' >The reset code would be sent to your mail</ERCText>
            </div> */}
        </div>
        // <RadaForm
        //     className={formClass}
        //     btnText={currentForm.btnText} url={currentForm.url} onSuccess={currentForm.onSuccess}
        //     method={currentForm.method} validationSchema={currentForm.schema}

        // >
        //     <Text size={20} weight={600} className={'text-center'}>
        //         {currentForm.header}
        //     </Text>

        //     <div className='w-[400px] mt-[30px]'>
        //         {
        //             currentForm.fields.map(field => <Input key={field.label} {...field} />)
        //         }
        //         {
        //             currentForm.Component
        //         }
        //     </div>
        // </RadaForm>
    )
}

export default ForgotPasswordModal






// import ERCInput from 'components/Input'
// import { ERCButton } from 'components/button'
// import { ERCText } from 'components/text'
// import React from 'react'

// const ForgotPasswordModal = () => {
//     return (
//         <div style={{ padding: '58px 220px', display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }} >

//             <ERCText size='32px' weight='700' lHeight='40px' color='#050505' align='center' >
//                 Forgot Password?
//             </ERCText>
//             <ERCInput containerClass='!w-[430px] mt-[80px] ' label='Email Address/Phone Number' placeholder='Enter email address or phone number' />
//             <ERCButton weight='700' color='#00296B' bgcolor='#FFD600' className='!mt-[56px] mb-[16px]' width='430px' size='16px' > Submit </ERCButton>
//             <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }} >
//                 <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
//                     <g clip-path="url(#clip0_1058_2665)">
//                         <path d="M7.375 4.375H8.625V5.625H7.375V4.375ZM7.375 6.875H8.625V10.625H7.375V6.875ZM8 1.25C4.55 1.25 1.75 4.05 1.75 7.5C1.75 10.95 4.55 13.75 8 13.75C11.45 13.75 14.25 10.95 14.25 7.5C14.25 4.05 11.45 1.25 8 1.25ZM8 12.5C5.24375 12.5 3 10.2563 3 7.5C3 4.74375 5.24375 2.5 8 2.5C10.7563 2.5 13 4.74375 13 7.5C13 10.2563 10.7563 12.5 8 12.5Z" fill="#FFD600" />
//                     </g>
//                     <defs>
//                         <clipPath id="clip0_1058_2665">
//                             <rect width="15" height="15" fill="white" transform="translate(0.5)" />
//                         </clipPath>
//                     </defs>
//                 </svg>
//                 <ERCText color='#9A9AAA' size='14px' weight='600' lHeight='20px' >The reset code would be sent to your mail</ERCText>
//             </div>
//         </div>
//     )
// }

// export default ForgotPasswordModal
